<template>
  <div class="box-wrapper">
    <div class="box">
      <div class="box-header">
        <span class="title">작업현황</span>
        <div class="icons">
          <el-button type="primary" size="mini" @click="openWorkSettingPopup">금일 작업 추가 </el-button>
          <el-button type="content" size="mini" @click="goWorkManagementPage"> 작업관리 바로가기 </el-button>
         </div>
      </div>
      <div class="box-content">
        <div class="task-wrapper">
          <div class="inner-container" @click="(isWork(item) ? onClickWorkDate(item) : '')" :style="isWork(item) ? 'cursor: pointer' : 'cursor: default'" v-for="item in workCountForDay" :key="item.selectedDate">
            <div :class="(isToDay(item) ? 'day today' : 'day')">{{item.label}}</div>
            <div :class="(isToDay(item) ? 'date today' : 'date')">{{dateStringFormatter(item.selectedDate)}}</div>
            <!-- 작업 있을때 -->
            <div class="has-task" v-if="isWork(item)">작업수<span>{{item.workCount}}</span>건</div>
            <div class="no-task" v-else>작업없음</div>
          </div>
        </div>
        <w-setting-work-sliding-popup ref="settingWorkPopup" :popup-params="popupParams" @close="onSettingPopupClose"></w-setting-work-sliding-popup>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import perfAPI from '@/api/performance/root';
import workManageAPI from '@/api/work/work';
import { menuDefine } from '@/constants/menu';
import WSettingWorkSlidingPopup from '@/views/work/popup/SettingWorkSlidingPopup';

export default {
  name: 'WSummaryWorkCount',
  components: {
    WSettingWorkSlidingPopup,
  },
  data() {
    return {
      workCountForDay: [],
      basicinfoSubDatas: {},
      popupParams: {},
    };
  },
  props: {
    active: {
      type: Boolean,
    },
  },
  watch: {
    active() {
      if (this.active) {
        this.basicinfoSubloadStore();
        this.loadData();
      }
    },
  },
  mounted() {
    this.basicinfoSubloadStore();
    this.loadData();
  },
  methods: {
    /**
     * 작업 보유 여부
     * @author leesy918
     * @param  {[type]}  item [description]
     * @return {Boolean}      [description]
     */
    isWork(item) {
      return (item.workCount > 0);
    },
    /**
     * 당일 판별 여부
     * @author leesy918
     * @param  {[type]}  item [description]
     * @return {Boolean}      [description]
     */
    isToDay(item) {
      const time = item.selectedDate;
      const now = new Date();
      const compTime = new Date(time);
      return (compTime.getDay() === now.getDay());
    },
    dateStringFormatter(date) {
      const day = new Date(date);
      return day.getDate();
    },
    loadData() {
      const params = {
        selectedDate: moment(new Date()).hours(0).minute(0).second(0),
      };
      perfAPI.getPerfWorkCount(params).then((response) => {
        if (response.data.success) {
          this.workCountForDay = response.data.data;
        }
      });
    },
    /**
     * 작업관리 바로가기
     * @author leesy918
     * @return {[type]} [description]
     */
    goWorkManagementPage() {
      this.$router.push({ path: `/${menuDefine.WORK}` });
    },
    basicinfoSubloadStore() {
      workManageAPI.getBasicInfoSubList().then((response) => {
        if (response.data.success === true) {
          this.basicinfoSubDatas = response.data.data;
        }
      });
    },
    openWorkSettingPopup() {
      const now = new Date();
      const popupParams = {
        popupTitle: '작업 추가',
        popupType: 'ADD',
        selectedDate: now,
        workTypeDatas: this.basicinfoSubDatas.workType,
        workImpactDatas: this.basicinfoSubDatas.workImpact,
      };
      this.popupParams = popupParams;
      this.$refs.settingWorkPopup.open();
    },
    onSettingPopupClose() {
      this.loadData();
    },
    /**
     * 작업 내역이 존재하는 날짜 선택 시 해당 작업 내역을 조회한다.
     * @author leesy918
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    onClickWorkDate(item) {
      if (item.workCount > 0) {
        const startDateTime = new Date();
        startDateTime.setTime(item.selectedDate);
        startDateTime.setHours(0);
        startDateTime.setMinutes(0);
        startDateTime.setSeconds(0);
        const endDateTime = new Date();
        endDateTime.setTime(item.selectedDate);
        endDateTime.setHours(23);
        endDateTime.setMinutes(59);
        const param = {
          startDatetime: startDateTime.getTime(),
          endDatetime: endDateTime.getTime(),
        };
        this.$store.dispatch('openWorkDetailPopup', param);
      }
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/performance/root/components/SummaryWorkCount.vue